import React, { useState, useEffect, useContext } from "react";
import "../../AppointmentHistory/Appointments.scss";
import CustomModal from "../../UI Component/Modal/ModalCustom";
import { filterRecords, filters, getDateByRanges } from "./constants";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import moment from "moment";
import useWindowSize from "../../../Hooks/useWindowSize";
import DoctorContext from "../../ClinicComponents/ClinicWrapper/DoctorContext";
import { checkPermission } from "../../ClinicComponents/CommonComponents/userPermission/userPermission";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";

export default function FilterPatientsModal(props) {
  const {
    show,
    handleClose,
    date,
    appointmentStatus,
    status,
    prescriptionStatus,
    start,
    end,
    onFilterSuccess,
    onResetFilter,
    selectedAppointmentType,
    mobileFilterData,
  } = props;
  const [sideMenu, setSideMenu] = useState("status");
  const size = useWindowSize();

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    dateDisplayFormat: "DD MMM YYYY",
    rangeColors: "#F969A4",
    color: "#F969A4",
    key: "selection",
  });
  const [filterData, setFilterData] = useState({
    appointmentStatus: "",
    status: "",
  });
  const [allFilters, setAllFilters] = useState();
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [resetFilterData, setResetFilterData] = useState({
    appointmentStatus: "all",
    status: "all",
  });
  let doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  let staffClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION
  );

  let doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const doctor_context = useContext(DoctorContext);

  useEffect(() => {
    setFilterData({
      appointmentStatus: appointmentStatus,
      status: status,
      prescriptionStatus: prescriptionStatus,
      date: date || "Today",
    });
    setAllFilters(mobileFilterData);
    setSelectionRange({
      ...selectionRange,
      startDate: start != "" ? new Date(start) : new Date(),
      endDate: end != "" ? new Date(end) : new Date(),
    });
  }, []);

  useEffect(() => {
    if (
      (doctorRole &&
        doctorRole != "consultant" &&
        (staffClinicAssociation === "true" ||
          doctorClinicAssociation === "true") &&
        clinicId &&
        clinicId !== undefined) ||
      checkPermission()
    ) {
      let list = [
        { name: "All", value: "all" }, //, doctor_id: doctor_selected
        ...doctor_context?.selectedDoctor,
      ];
      let temp;
      temp = filters;
      temp.doctorName = list;
    } else {
      // delete filters["sideMenu"] = doctorName;
    }
  }, [doctor_context.selectedDoctor]);

  const onHandleMethodCall = (item) => {
    const sideBar = filters.sideMenu.find((filter) => filter.value == sideMenu);

    if (sideMenu === "date") {
      const range = getDateByRanges(item.value);
      setSelectionRange({
        ...selectionRange,
        startDate: new Date(range.startDate),
        endDate: new Date(range.endDate),
      });
    }
    if (sideMenu !== "date") {
      setAllFilters({ ...allFilters, [sideBar.value]: item });
    }
    if (sideMenu === "doctorName") {
      setFilterData({ ...filterData, [sideBar.value]: item.doctor_id });
    } else {
      setFilterData({
        ...filterData,
        [sideBar.value]: item.value,
      });
    }
  };

  const getFilterValues = (label) => {
    setSelectedStatus(label);
  };
  //   const onCloseCall = () => {
  //     onFilterSuccess({
  //       status: filterData.status,
  //       appointmentStatus: filterData.appointmentStatus,
  //       prescriptionStatus: filterData.prescriptionStatus,
  //       startDate: selectionRange.startDate
  //         ? selectionRange.startDate
  //         : new Date(),
  //       endDate: selectionRange.endDate ? selectionRange.endDate : new Date(),
  //       allFilters,
  //       resetValues,
  //     });
  //   };

  const handleSelect = (ranges) => {
    setSelectionRange(ranges);
  };

  const DateTimeRangeRender = () => {
    return (
      <DateRangePicker
        ranges={[selectionRange]}
        startDatePlaceholder="From"
        endDatePlaceholder="To"
        showSelectionPreview={true}
        editableDateInputs={true}
        showPreview={false}
        staticRanges={[]}
        inputRanges={[]}
        dragSelectionEnabled={true}
        onChange={(item) => handleSelect(item.selection)}
        className="range-only-date m-auto"
        maxDate={moment().add(1, "years").toDate()}
      />
    );
  };

  return (
    <CustomModal show={show && size.width < 1024 ? show : false}>
      <div className="d-flex col-sm-12 d-lg-none appointment-filter-header-div">
        <div className="appointment-filter-header-tittle-div">Filters</div>
        <div className="ml-auto" onClick={() => handleClose()}>
          Close
          <i className="fa fa-close pl-1" aria-hidden="true"></i>
        </div>
      </div>

      <div className={`appointment-filter-body-div d-flex `}>
        <div className={`appointment-filter-body-sidebar-div col-sm-6 p-0`}>
          {filters.sideMenu.map((item, i) => {
            if (
              selectedAppointmentType &&
              selectedAppointmentType.value === "upcoming" &&
              item.value === "prescriptionStatus"
            ) {
              return null;
            } else
              return (
                <div
                  className={`${sideMenu === item.value ? "active" : ""}`}
                  key={i}
                  onClick={() => {
                    setSideMenu(item.value);
                    getFilterValues(item.value);
                  }}
                >
                  {item.name}
                </div>
              );
          })}
        </div>

        <div className="col-sm-6">
          {filters[sideMenu].map((item, i) => {
            let status;
            if (
              selectedStatus === "appointmentStatus" &&
              selectedAppointmentType &&
              (selectedAppointmentType.value === "upcoming" ||
                selectedAppointmentType.value === "past")
            ) {
              status = filterRecords(selectedAppointmentType.value, item.value);
              if (filterRecords(selectedAppointmentType.value, item.value)) {
                return (
                  <div
                    className="appointment-filter-body-right-div"
                    key={i}
                    onClick={() => onHandleMethodCall(item)}
                  >
                    <i
                      className={`fa fa-check mr-1 check-icon-filter ${
                        filterData[sideMenu] === item.value ? "activeTab" : ""
                      }`}
                      aria-hidden="true"
                    ></i>
                    {(item.name, filterData[sideMenu])}
                  </div>
                );
              }
            } else {
              return (
                <div
                  className="appointment-filter-body-right-div"
                  key={i}
                  onClick={() => onHandleMethodCall(item)}
                >
                  <i
                    className={`fa fa-check mr-1 check-icon-filter ${
                      filterData[sideMenu] === item.value ? "activeTab" : ""
                    }`}
                    aria-hidden="true"
                  ></i>
                  {item.name}
                </div>
              );
            }
          })}
        </div>
      </div>

      <div className="d-flex col-sm-12 appointment-date-range-buttons-div p-2">
        <a
          className="ml-auto appointment-date-range-reset"
          onClick={() => {
            onResetFilter(resetFilterData);
          }}
        >
          Reset All
        </a>
        <button
          className="ml-2 btn-primary appointment-date-range-apply"
          onClick={() => onFilterSuccess(filterData)}
        >
          Apply
        </button>
      </div>
    </CustomModal>
  );
}
